import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { Observable } from 'rxjs';
import { NotificationType } from '../enum/notification-type.enum';
import { NotificationService } from '../notification/notification.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private notification: NotificationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.authenticationService.isLogin()) {
      localStorage.setItem('redirectUrl', state.url);
      this.router.navigate(['/auth/login']).then(() => {
        this.notification.notify(
          NotificationType.WARNING,
          'Vous devez vous connecter pour accéder à cette page',
          ''
        );
      });
      return false;
    }
    return true;
  }
}
